import { useAsync, useMutation } from "./useAsync";
import * as api from "../lib/api";

/** Admin-only mutation for granting the current admin access to any tutorial. */
export function useAdminGrantCourseToDashboard() {
  return useMutation((courseId: string) => api.addAdminCourseToDashboard(courseId));
}

/** Admin-only list of learner tutorial access rows that can be extended. */
export function useAdminCourseAccessTimeline() {
  return useAsync(() => api.getAdminCourseAccessTimeline(), []);
}

/** Admin-only mutation for extending a learner's tutorial access for free. */
export function useAdminExtendCourseAccess() {
  return useMutation((permissionId: string, days: number) =>
    api.extendAdminCourseAccess(permissionId, days),
  );
}
